import React from 'react';
export const Header = () => {
  return <header className="w-full text-white py-3 px-4 md:px-8" style={{
    backgroundColor: '#442b63'
  }} data-id="element-194">
      <div className="container mx-auto flex items-center" data-id="element-195">
        <div className="flex items-center" data-id="element-196">
          <div className="mr-3 relative h-10 w-10 flex items-center justify-center" data-id="element-197">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wbputTPKGLBnyq8nHNH1GM/ChatGPT_Image_Aug_26%2C_2025%2C_02_22_48_PM.png" alt="Frauengesundheit Logo" className="h-full w-full object-contain" data-id="element-198" />
          </div>
          <div data-id="element-199">
            <h1 className="font-bold text-lg md:text-xl text-white" data-id="element-200">
              Frauengesundheit
            </h1>
            <p className="text-sm -mt-1 text-white" data-id="element-201">Wissen</p>
          </div>
        </div>
      </div>
    </header>;
};